import { lazy } from "react";
import type { RouteObject } from "react-router";
import { ProtectedRoute } from "@/src/auth/components/protected-route";
import { ChildcareGuard } from "@/src/childcare/components/childcare-guard";
import { CHILDCARE_ADMIN_ROLES, CHILDCARE_PARENT_ROLES, CHILDCARE_STAFF_ROLES } from "@/src/childcare/constants/childcare.constants";
import { CHILDCARE_ROUTES } from "@/src/childcare/constants/childcare-routes.constants";

const AttendancePage = lazy(() => import("@/src/childcare/pages/daily-attendance.page"));
const ChildrenPage = lazy(() => import("@/src/childcare/pages/children.page"));
const ChildDetailPage = lazy(() => import("@/src/childcare/pages/child-detail.page"));
const ReportsPage = lazy(() => import("@/src/childcare/pages/childcare-reports.page"));
const TermsPage = lazy(() => import("@/src/childcare/pages/terms.page"));
const MyChildrenPage = lazy(() => import("@/src/childcare/pages/my-children.page"));

export const childcareRoutes: RouteObject[] = [
	{
		element: <ProtectedRoute requiredRole={[...CHILDCARE_STAFF_ROLES]} />,
		children: [
			{
				element: <ChildcareGuard />,
				children: [
					{ path: CHILDCARE_ROUTES.attendance, element: <AttendancePage /> },
					{ path: CHILDCARE_ROUTES.children, element: <ChildrenPage /> },
					{ path: CHILDCARE_ROUTES.childDetail, element: <ChildDetailPage /> },
					{ path: CHILDCARE_ROUTES.reports, element: <ReportsPage /> },
				],
			},
		],
	},
	{
		element: <ProtectedRoute requiredRole={[...CHILDCARE_ADMIN_ROLES]} />,
		children: [{ path: CHILDCARE_ROUTES.terms, element: <TermsPage /> }],
	},
	{
		element: <ProtectedRoute requiredRole={[...CHILDCARE_PARENT_ROLES]} />,
		children: [{ path: CHILDCARE_ROUTES.myChildren, element: <MyChildrenPage /> }],
	},
];
